/**
 * Keresés
 *
 * @author M.Tomi
 * @returns {undefined}
 */

var bookFilter = {
    settings: {
        /**
         * konzol bejegyzéseket mutat
         * @boolen
         */
        debug: true,

        /**
         * Ajax hívás módja
         * @string GET|POST
         */
        ajaxMethod: 'GET',
        ajaxUrl : '/ajaxRequest/book/filter',
        target : null,
        container : null,
        filterForm : null,
        uriObj : null,
        activeTabId : null,
        defaultTabId : 'all',
    },
    /**
     * Inicializálás
     */
    init: function() {
        this.debugLog('bookFilter init...');
        this.filterForm = $('form#filter');
        this.target = $('#bookPlaceholder');

        this.initUI();

        this.uriObj = this.getUriParameters();
        this.debugLog('URI:', this.uriObj);

        $('.filterOnChange').change(function(e){
            e.preventDefault();
            var requestParams = bookFilter.serializeForm();
            bookFilter.debugLog(requestParams);
            if (requestParams !== undefined) {
                bookFilter.callAjax(bookFilter.settings.ajaxUrl, requestParams);
            }
        });

        var tabId;
        if(this.uriObj.tabid) {
            tabId = this.uriObj.tabid;
        }
        else {
            tabId = this.settings.defaultTabId;
        }

        // $('.asyncTabs a').removeClass('active').removeClass('btn-gray').addClass('btn-outline-gray');
        // $('.asyncTabs a[data-tabid="'+tabId+'"]').addClass("active").addClass('btn-gray').removeClass('btn-outline-gray');
        this.tabChange(tabId);


        $(window).bind('popstate', function(e) {
            this.debugLog('popstate');
        });


        //var tabId = $('.pAjaxTabs li.active a').attr('data-tabid')
        //this.activeTabId = tabId;
        //console.log('tabid:', tabId);


        $('.asyncTabs a').click(function(e){
            e.preventDefault();
            var tabId = $(this).attr('data-tabid');
            bookFilter.tabChange(tabId);
            bookFilter.callAjax(bookFilter.settings.ajaxUrl, bookFilter.serializeForm());
        });

        //
        this.callAjax(this.settings.ajaxUrl, this.serializeForm());
    },
    tabChange : function(tabId) {
        this.activeTabId = tabId;
    },
    serializeForm: function() {
        return this.filterForm.serialize();
    },
    initUI : function() {
        $('#c_opt_all').change(function(){
            if($(this).is(':checked')) {
                $('.generatedOpt').prop('checked', false);
            }
        });
        $('.generatedOpt').change(function(){
            if($(this).is(':checked') &&  $('#c_opt_all').is(':checked')) {
                $('#c_opt_all').prop('checked', false);
            }
        });
    },
    /**
     * AJAX kérés indítás
     * @param   {string} request      url
     * @param   {object} extraParams  kérés paraméterei (get|post)
     */
    callAjax : function(request, extraParams) {
        if(request) {
            this.debugLog('Calling ajax request to: '+request);
            this.debugLog('With params:');
            this.debugLog(extraParams);
            if(extraParams) {
                extraParams += '&tabid=' + this.activeTabId;
            } else {
                extraParams = "tabid=" + this.activeTabId
            }
            history.pushState(null, null, location.pathname+'?'+extraParams);
            $.ajax({
                type: bookFilter.settings.ajaxMethod,
                url: request,
                data: extraParams,
                dataType: "html",
                beforeSend: function() {
                    var img =  $('<img>').attr('src', '/components/kieselbach/front/assets/images/ajax-loader.gif')
                        .css({
                            position: 'absolute',
                            left: '50%',
                            top: '22%',
                        })
                        .addClass('ajaxLoader')
                        .appendTo($('body'));
                },
                success: function (response) {
                    bookFilter.rebuildHtmlContent(bookFilter.target, response);
                }
            });
        }
        else{
            this.debugLog('Calling ajax: no request');
        }
    },
    /**
     * Lapozó gombok click eseménye
     * @param {object} item   lapozó gomb DOM elem
     */
    paginationClickEvent: function(item) {
        var page = item.data('page');
        if(page) {
            var requestParams = this.serializeForm();
            requestParams += '&page='+page;
            bookFilter.debugLog('requestParam', requestParams);
            if (requestParams !== undefined) {
                bookFilter.callAjax(this.settings.ajaxUrl, requestParams);
            }
        }
        else {
            bookFilter.debugLog(item);
            bookFilter.debugLog('pagination click: no page request');
        }
    },
    /**
     * HTML Tab tartalmát generálja a data paraméter alapján
     * @param {jQueryObject} target   Az a DOM elem, amibe bele kell generálni a tartalmat
     * @param {string} data           Az adatok, amit bele kell generálni a target konténerbe
     */
    rebuildHtmlContent : function(target, data) {
        var currentHeight = target.height();
        this.debugLog('current target height:'+currentHeight);

        /*if(currentHeight > 0) {
         target.height(currentHeight);
         this.debugLog('target height setted to:'+currentHeight);
         }*/

        // target.find('.asyncContent').remove();
        target.html(data);

        target.find('.pagination .page-link').click(function(e) {
            e.preventDefault();
            bookFilter.paginationClickEvent($(this));
        });

        // target
        //     .find('.tiles-wrap')
        //     .imagesLoaded(function () {
        //         target.find('.asyncContent').fadeIn('slow');
        //         $(this.elements).wookmark({
        //             // Prepare layout options.
        //             autoResize: true, // This will auto-update the layout when the browser window is resized.
        //             offset: 20 // Optional, the distance between grid items
        //         });
        //     });
        $('.ajaxLoader').remove();

        $('.asyncTabs a').removeClass('active').removeClass('btn-gray').addClass('btn-outline-gray');
        $('.asyncTabs a[data-tabid="'+this.activeTabId+'"]').addClass("active").addClass('btn-gray').removeClass('btn-outline-gray');

        $(window).scrollTop(target.offset().top - 250).scrollLeft(target.offset().left);

    },
    /**
     * Debuglog
     *
     * Settings alapján ír konzol debug bejegyzéseket
     */
    debugLog: function () {
        if (this.settings.debug) {
            console.log(arguments);
        }
    },
    getUriParameters : function() {
        return (document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = decodeURIComponent(n[1]),this}.bind({}))[0];
    }
}

$(function() {
    // all
    if($('#bookPlaceholder').length) {
        bookFilter.init();
    }
});